import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=74b31d99&scoped=true"
import script from "./userInfo.vue?vue&type=script&lang=js"
export * from "./userInfo.vue?vue&type=script&lang=js"
import style0 from "./userInfo.vue?vue&type=style&index=0&id=74b31d99&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b31d99",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74b31d99')) {
      api.createRecord('74b31d99', component.options)
    } else {
      api.reload('74b31d99', component.options)
    }
    module.hot.accept("./userInfo.vue?vue&type=template&id=74b31d99&scoped=true", function () {
      api.rerender('74b31d99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/userCard/userInfo.vue"
export default component.exports